import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  L: number; // Largeur extérieure
  H: number; // Hauteur extérieure
  l: number; // Largeur intérieure
  h: number; // Hauteur intérieure
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.CANTILEVER_REINFORCEMENT,
  image: "/images/assets/potence-renfort.png",
  submittedBy: SubmittingOrganization.PCM,
  inputs: [
    {
      key: "L",
      type: "dimension",
    },
    { key: "H", type: "dimension" },
    { key: "l", type: "dimension" },
    { key: "h", type: "dimension" },
  ],
  build: (params, offset) => {
    const { L, H, l, h } = params;

    return [
      {
        type: "polyline",
        points: [
          [offset[0] - L / 2, offset[1] - H / 2, offset[2]],
          [offset[0] + L / 2, offset[1] - H / 2, offset[2]],
          [offset[0] + L / 2, offset[1] + H / 2, offset[2]],
          [offset[0] - L / 2, offset[1] + H / 2, offset[2]],
          [offset[0] - L / 2, offset[1] - H / 2, offset[2]],
        ],
      },
      {
        type: "polyline",
        points: [
          [offset[0] - l / 2, offset[1] - h / 2, offset[2]],
          [offset[0] + l / 2, offset[1] - h / 2, offset[2]],
          [offset[0] + l / 2, offset[1] + h / 2, offset[2]],
          [offset[0] - l / 2, offset[1] + h / 2, offset[2]],
          [offset[0] - l / 2, offset[1] - h / 2, offset[2]],
        ],
      },
    ];
  },
};
export default asset;
